import { version } from 'vue';

declare global {
  interface Window {
    isVue2: boolean
  }
}

export function initializeShellMetadata(): void {
  try {
    // Get Vue version from either the Vue instance or imported version constant
    const vueVersion = version

    // Store metadata globally on window object for cross-app access
    // This allows micro-frontends to check: window.isVue2
    window.isVue2 = vueVersion?.startsWith('2.') || false

  } catch (error) {
    window.isVue2 = false
   }
}
